import { Icon, type IconProps } from "@chakra-ui/react";

function LightMode(props: IconProps) {
  return (
    <Icon viewBox="0 0 14 14" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6.5 0H7.5V2H6.5V0ZM11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7ZM7.5 14V12H6.5V14H7.5ZM0 6.5H2V7.5H0V6.5ZM3.11091 3.81802L3.81802 3.11091L2.40381 1.6967L1.6967 2.40381L3.11091 3.81802ZM1.6967 11.5962L3.11091 10.182L3.81802 10.8891L2.40381 12.3033L1.6967 11.5962ZM14 6.5H12V7.5H14V6.5ZM12.3033 11.5962L11.5962 12.3033L10.182 10.8891L10.8891 10.182L12.3033 11.5962ZM12.3033 2.40381L11.5962 1.6967L10.182 3.11091L10.8891 3.81802L12.3033 2.40381Z" fill="#F69B13" />
    </Icon>
  );
}

export default LightMode;
